import BaseException from './base_exception'

class InvalidNumberFormat extends BaseException {
  constructor(value) {
    super('hs.errors.invalid_number_format', { value })
  }
}

export default InvalidNumberFormat
